module.exports = __webpack_public_path__ + "d939dcac611747f6857eb4b92cb14c8e.svg";